import {AddSignature, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalAddSignature extends AddSignature implements Parameter {
	public newName?: string;
	public visible?: boolean;

	constructor(data: any) {
		super(data);

		this.newName = FunctionHelper.exists(data?.newName) ? data.newName : "";
		this.visible = FunctionHelper.exists(data?.visible) ? data.visible : false;
	}

	public static getNewNameDefault(): string {
		return "";
	}

	public static getVisibleDefault(): boolean {
		return false;
	}

	public static fromJson(data: any): PortalAddSignature {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalAddSignature(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'newName': this.newName,
			'visible': this.visible
		};
	}

	public clone(): PortalAddSignature {
		return PortalAddSignature.fromJson(this.toJson());
	}
}